module.exports = __webpack_public_path__ + "assets/images/project/people/man-chart.png?v=490824bc";